module.exports = __webpack_public_path__ + "static/img/item9.b013eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item9.png
// module id = bqfN
// module chunks = 1